/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type ComponentType, Suspense, lazy } from 'react';
import type { DependencyGraphProps } from './DependencyGraphContent';

export type { DependencyGraphProps } from './DependencyGraphContent';

const LazyDependencyGraphContent = lazy(() =>
  import('./DependencyGraphContent').then(m => ({
    default: m.DependencyGraph as ComponentType<any>,
  })),
);

/**
 * Graph component used to visualize relations between entities
 *
 * @public
 */
export function DependencyGraph<NodeData, EdgeData>(
  props: DependencyGraphProps<NodeData, EdgeData>,
) {
  return (
    <Suspense fallback={<div />}>
      <LazyDependencyGraphContent {...props} />
    </Suspense>
  );
}
